import React, { useState, useMemo, useEffect } from "react";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as Trash } from "../../assets/analyse/Trash.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";

import DropdownList from "react-widgets/DropdownList";
import countryList from "react-select-country-list";
import "react-widgets/styles.css";
import "react-toastify/dist/ReactToastify.css";
import ComponentLoading from "../../commonComponents/ComponentLoading";
import LossComponent from "./LossComponent";

// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  updateOriginQuantity,
  updateOriginQuantityLocal,
  updateOriginValue,
  updateOriginValueLocal,
  addOrigin,
  addOriginLocal,
  removeOrigin,
  removeOriginLocal,
  updateIngredientTransport,
  updateIngredientTransportLocal,
  updateIngredientTransportLocalQuantity,
  updateIngredientTransportQuantity,
  addIngredientTransport,
  addIngredientTransportLocal,
  removeIngredientTransport,
  removeIngredientTransportLocal,
  updateFlow,
  updateFlowLocal,
  updateFlowQuantity,
  updateFlowQuantityLocal,
  removeFlowFromStep,
  removeFlowFromStepLocal,
  removeIngredient,
  removeIngredientLocal,
  updateIngredientTransportOrigin,
  updateIngredientTransportOriginLocal,
  updateFlowDescriptionLocal,
  updateFlowDescription
} from "../../redux/actions/analysisActions";
import { setUserOnboardingStep, setUserOnboardingStepLocal } from "../../redux/actions/userActions";
import { fetchFlowTypeMeta } from "../../redux/actions/flowActions";

import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

// utils
import { renderFlag, getTypeParameterText, get_loss_data, get_total_loss, StrSplit, get_transport_country } from "../../utils/utils.js";

const ModificationLine = ({
  changable,
  setModifying,
  width,
  item,
  data,
  modifying,
  flow_id,
  icon,
  quantity,
  quantityUnit,
  imapct_factors,
  step,
  line_index,
  columns,
  modIndex,
  setModIndex,
  loss,
  raw_to_cooked,
  k_type,
  description,
}) => {
  function getCountryName(code) {
    const default_obj = options.find((x) => x.value === code);
    return default_obj;
  }

  // REDUX DATA
  const flow_type_meta = useSelector((state) => (state.flow.flow_type_meta ? state.flow.flow_type_meta : null));
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const fetchFlowTypeMeta_rd = (item) => dispatch(fetchFlowTypeMeta(item));

  const updateOriginQuantity_rd = (item) => dispatch(updateOriginQuantity(item));
  const updateOriginQuantityLocal_rd = (item) => dispatch(updateOriginQuantityLocal(item));
  const updateOriginValue_rd = (item) => dispatch(updateOriginValue(item));
  const updateOriginValueLocal_rd = (item) => dispatch(updateOriginValueLocal(item));
  const addOrigin_rd = (item) => dispatch(addOrigin(item));
  const addOriginLocal_rd = (item) => dispatch(addOriginLocal(item));
  const removeOrigin_rd = (item) => dispatch(removeOrigin(item));
  const removeOriginLocal_rd = (item) => dispatch(removeOriginLocal(item));

  const updateIngredientTransport_rd = (item) => dispatch(updateIngredientTransport(item));
  const updateIngredientTransportLocal_rd = (item) => dispatch(updateIngredientTransportLocal(item));

  const updateIngredientTransportLocalQuantity_rd = (item) => dispatch(updateIngredientTransportLocalQuantity(item));
  const updateIngredientTransportQuantity_rd = (item) => dispatch(updateIngredientTransportQuantity(item));
  const addIngredientTransport_rd = (item) => dispatch(addIngredientTransport(item));
  const addIngredientTransportLocal_rd = (item) => dispatch(addIngredientTransportLocal(item));
  const removeIngredientTransport_rd = (item) => dispatch(removeIngredientTransport(item));
  const removeIngredientTransportLocal_rd = (item) => dispatch(removeIngredientTransportLocal(item));

  const updateFlowQuantity_rd = (item) => dispatch(updateFlowQuantity(item));
  const updateFlowQuantityLocal_rd = (item) => dispatch(updateFlowQuantityLocal(item));

  const updateFlow_rd = (item) => dispatch(updateFlow(item));
  const updateFlowLocal_rd = (item) => dispatch(updateFlowLocal(item));

  const removeFlowFromStep_rd = (item) => dispatch(removeFlowFromStep(item));
  const removeFlowFromStepLocal_rd = (item) => dispatch(removeFlowFromStepLocal(item));
  const removeIngredient_rd = (item) => dispatch(removeIngredient(item));
  const removeIngredientLocal_rd = (item) => dispatch(removeIngredientLocal(item));

  const updateIngredientTransportOriginLocal_rd = (item) => dispatch(updateIngredientTransportOriginLocal(item));
  const updateIngredientTransportOrigin_rd = (item) => dispatch(updateIngredientTransportOrigin(item));

  const updateFlowDescriptionLocal_rd = (item) => dispatch(updateFlowDescriptionLocal(item));
  const updateFlowDescription_rd = (item) => dispatch(updateFlowDescription(item));

  const setUserOnboardingStep_rd = (item) => dispatch(setUserOnboardingStep(item));
  const setUserOnboardingStepLocal_rd = (item) => dispatch(setUserOnboardingStepLocal(item));
  const handleChangeOnboardingStep = (item) => {
    setUserOnboardingStep_rd(item);
    setUserOnboardingStepLocal_rd(item);
  };

  // LOCAL VARIABLES
  const [loading, setLoading] = useState(false);
  const options = useMemo(
    () => [
      ...countryList().getData(),
      { value: "RoW", label: "Reste du monde" },
      { value: "GLO", label: "Globale" },
      { value: "RER", label: "Union européenne" },
      { value: "NAN", label: "Inconnu" },
      { value: "INDEF", label: "Non défini" },
    ],
    []
  );

  // RECEIP STEP ACTIONS HANDLERS --- ORIGIN
  const handleChangeOriginQuantity = async (event, current, i) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      quantity: event.target.value * 10 ** -2,
      flow_id: flow_id,
      current: current,
      index_origin: i,
      type: "update_origin_quantity",
    };
    await updateOriginQuantityLocal_rd(item);
    updateOriginQuantity_rd(item);
    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeOriginValue = async (value, i, current) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      quantity: value.value,
      current: current,
      flow_id: flow_id,
      index_origin: i,
      type: "origin_value",
    };
    await updateOriginValueLocal_rd(item);
    updateOriginValue_rd(item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeAddOrigin = async (value, i) => {
    let item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      flow_id: flow_id,
      type: "add_origin",
    };
    const new_item = await addOriginLocal_rd(item);
    // item.flow_uid = flow_uid;
    addOrigin_rd(new_item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeRemoveOrigin = (current, i) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      flow_meta: flow_type_meta[0],
      flow_id: flow_id,
      current: current,
      transport_id: parseFloat(i),
      type: "remove_origin",
    };
    removeOrigin_rd(item);
    removeOriginLocal_rd(item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  // RECEIP STEP ACTIONS HANDLERS --- TRANSPORT
  const handleChangeIngredientTransportQuantity = (event, current, i) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      quantity: event.target.value,
      current: current,
      flow_id: flow_id,
      index_transport: i,
      type: "ingredient_transport_quantity",
    };
    updateIngredientTransportLocalQuantity_rd(item);
    updateIngredientTransportQuantity_rd(item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeIngredientTransport = async (value, current, i, origin) => {
    const item = {
      origin: origin,
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      quantity: value,
      current: current,
      flow_id: flow_id,
      index_transport: i,
      type: "ingredient_transport_type",
    };
    await updateIngredientTransportLocal_rd(item);
    await updateIngredientTransport_rd(item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeAddIngredientTransport = async (value) => {
    const item = {
      origin: value,
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      flow_meta: flow_type_meta[0],
      flow_id: flow_id,
      type: "add_ingredient_transport",
    };
    const new_item = await addIngredientTransportLocal_rd(item);
    
    addIngredientTransport_rd(new_item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeRemoveIngredientTransport = (current, i) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      flow_meta: flow_type_meta[0],
      flow_id: flow_id,
      current: current,
      transport_id: i,
      type: "remove_ingredient_transport",
    };
    removeIngredientTransport_rd(item);
    removeIngredientTransportLocal_rd(item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };

  // RECEIP STEP ACTIONS HANDLERS
  const handleChangeFlowQuantity = (e) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      quantity: e.target.value,
      flow_id: flow_id,
      type: "flow_quantity",
      k_type: k_type,
    };
    updateFlowQuantityLocal_rd(item);
    updateFlowQuantity_rd(item);
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeFlow = async (value, current) => {
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      flow_meta: value,
      flow_id: flow_id,
      current: current,
      type: "update_flow_type",
      k_type: k_type,
    };
    await updateFlowLocal_rd(item);
    updateFlow_rd(item);

    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
      handleChangeOnboardingStep(2);
    }
  };
  const handleChangeRemoveFlow = async () => {
    let item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      flow_id: flow_id,
      k_type: k_type,
      // flow_uid: Object.values(Object.values(analysis_data.lca.lca_steps)[Math.abs(step - 6)].inputs)[line_index].id,
    };
    if (step > 2) {
      item.type = "remove_flow";
      await removeFlowFromStep_rd(item);
      await removeFlowFromStepLocal_rd(item);
      if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
        handleChangeOnboardingStep(2);
      }
    } else {
      // remove ingredient
      item.type = "remove_ingredient";
      await removeIngredientLocal_rd(item);
      await removeIngredient_rd(item);
      // update onboarding step
      if (user_info.usage_info && user_info.usage_info.onboarding_step < 2) {
        handleChangeOnboardingStep(2);
      }
    }
    setModifying(0);
  };

  const [flow_description_timer, set_flow_description_timer] = useState(null);
  // DESCRIPTIOn
  const handleChangeFlowDescription = (e) => {
    console.log('handleChangeFlowDescription', e.target.value)
    const item = {
      analysis_id: analysis_id,
      process_id: line_index,
      step_index: Math.abs(step - 6),
      value: e.target.value,
      flow_id: flow_id,
      type: "flow_description",
      k_type: k_type,
    };
    updateFlowDescriptionLocal_rd(item)

    clearTimeout(flow_description_timer);
    const timeoutId = setTimeout(() => {
      updateFlowDescription_rd(item);
    }, 1000);
    set_flow_description_timer(timeoutId);

  }



  useEffect(() => {
    const fetchData = async () => {
      if (step <= 2 && Object.values(data).find((i) => i && i.category && i.category.name === "K_Transports")) {
        fetchFlowTypeMeta_rd("K_Transports");
      } else if (step > 2) {
        fetchFlowTypeMeta_rd(data.flow.category.name);
      }
    };

    fetchData();
  }, [data && data.flow]);

  return (
    <div className="w-full h-full">
      <div className="fixed right-0 top-[70px] bg-white h-[750px] w-[800px] border-[#F3F5F7] border-[0.1px]">
        {/* HEADER */}
        <div className={`border-[#F3F5F7] border-b-[1px] ml-[30px] mr-[90px]`}>
          <div className="w-full flex justify-between items-center">
            <div className="h-[70px] flex items-center justify-start font-Poppins-SemiBold text-lg">{item}</div>
            <button
              className="flex justify-between w-[100px]"
              onClick={() => {
                setModifying(0);
              }}
            >
              <p className="text-gray-400 font-Poppins-SemiBold">Retour</p>
              <BackArrow transform="rotate(180)" />
            </button>
          </div>

          {/* LOSS */}
          {loss && data && !data.name && <LossComponent total_loss={get_total_loss(loss, raw_to_cooked)} loss={loss} raw_to_cooked={raw_to_cooked} raw_to_cooked={raw_to_cooked} />}
        </div>

        {/* TEXT INDICATION */}
        {step <= 2 && modifying === 1 && data && !data.name && (
          <p className="px-[30px] font-Poppins-Light-Italic text-gray-400 text-sm mt-[20px] mr-[80px]">
            *Indiquez le pays de provenance et les transports utilisés pour acheminer le produit de chaque origine vers l'usine de transformation.
          </p>
        )}
        <div className={`w-full h-full mt-[${step <= 2 ? 20 : 20}px] flex justify-center `}>
          <div className="px-[30px] overflow-y-auto mb-[250px]">
            {/* RECEIP STEP */}
            {step <= 2 && modifying === 1 && data && !data.name && (
              <>
   
                {/* SHOW ORIGIN DATA */}
                {data &&
                  Object.values(data).find((i) => i.category.name === "K_Raw_Materials") &&
                  Object.values(data).find((i) => i.category.name === "K_Raw_Materials").inputs &&
                  Object.entries(Object.values(data).find((i) => i.category.name === "K_Raw_Materials").inputs).map(current => {
                    if (current[1] && (current[1] === null || !current[1].origin)) {
                      return null;
                    } else {
                      return (
                        <div className="w-full h-max bg-[#F3F5F7]/40 rounded-t shadow mr-[20px] bg-gray-200 mb-[40px]">
                          <div className="h-[40px] w-full flex items-center font-Poppins-SemiBold bg-white">
                            <div className="w-[338px] h-[40px] border-dotted border-r-[0.1px] border-[#F3F5F7] flex justify-center items-center">
                              <p> Origine</p>
                            </div>
                            <div className="w-[337px] h-[40px] border-dotted border-l-[0.1px] border-[#F3F5F7] flex justify-center items-center">
                              <p> Quantité</p>
                            </div>
                          </div>
                          <div className="flex bg-[#F3F5F7] flex-col" key={`${current[0]}`}>
                            <div className="flex  my-[10px] ">
                              <div className="h-[40px] w-[338px] flex items-center border-dotted border-r-[0.1px] border-[#F3F5F7]">
                                <button
                                  onClick={async () => {
                                    await handleChangeRemoveOrigin(current[1], current[0]);
                                  }}
                                >
                                  <Trash height={15} />
                                </button>


                                <DropdownList
                                  filter={"contains"}
                                  className="h-full w-[250px] bg-[#F3F5F7] py-[2px] pr-[10px]"
                                  data={options}
                                  dataKey="value"
                                  textField="label"
                                  renderValue={renderFlag}
                                  renderListItem={renderFlag}
                                  onChange={async (value) => await handleChangeOriginValue(value, current[0], current[1])}
                                  value={getCountryName(current[1].origin)}
                                />
                              </div>
                              <div className="w-[337px] h-[40px] border-dotted border-l-[0.1px] border-[#F3F5F7] flex justify-center items-center">
                                <p>
                                  <input
                                    onWheel={(e) => e.target.blur()}
                                    type={"number"}
                                    className={"text-right w-[50px] bg-transparent mr-[4px]"}
                                    max={100}
                                    min={0}
                                    onChange={async (event) => {
                                      await handleChangeOriginQuantity(event, current[1], current[0]);
                                    }}
                                    value={current[1].amount * 10 ** 2}
                                  />
                                  %
                                </p>
                              </div>
                            </div>

                            {/* ORIGIN TRANSPORT */}

                            <div className="flex ">
                              <div className="w-full h-full bg-[#F3F5F7]/40 rounded-t shadow ">
                                <div className="h-[40px] w-full flex items-center font-Poppins-SemiBold bg-white">
                                  <div className="w-[420px] h-[40px] border-dotted border-r-[1px] border-[#F3F5F7] flex justify-center items-center">
                                    <p>Transport</p>
                                  </div>
                                  <div className="flex-auto h-[40px] border-dotted border-l-[1px] border-[#F3F5F7] flex justify-center items-center">
                                    <p>Quantité</p>
                                  </div>
                                  <div className="flex-auto h-[40px] border-dotted border-l-[1px] border-[#F3F5F7] flex justify-center items-center">
                                    <p>Impact</p>
                                  </div>
                                </div>

                                {Object.values(data).find((i) => i.category.name === "K_Transports") && Object.values(Object.values(data).find((i) => i.category.name === "K_Transports").inputs)
                                  // .filter((x) => get_transport_country(x) === current.origin)
                                  .map((x, i) => {
                                    if (x && x.unit && x.unit.name === "kg") {
                                      return null;
                                    } else if (get_transport_country(x) === current[1].origin) {
                                      return (
                                        <div className="flex bg-[#F3F5F7]">
                                          <div className="h-[40px] ml-[-0.5px] w-[420px] flex items-center border-dotted border-r-[1px] border-[#F3F5F7]">
                                            <button
                                              onClick={async () => {
                                                await handleChangeRemoveIngredientTransport(x, i);
                                              }}
                                            >
                                              <Trash height={15} />
                                            </button>

                                            {/* <p
                                              onClick={() => {
                                                console.log("toto", x, i);
                                              }}
                                            >
                                              DEBUG
                                            </p> */}

                                            <DropdownList
                                              filter={"contains"}
                                              style={{ fontSize: 14 }}
                                              value={x.flow.name_fr ? x.flow.name_fr : null}
                                              className="h-full bg-[#F3F5F7] py-[2px] pr-[3px]"
                                              data={flow_type_meta ? flow_type_meta : []}
                                              textField={"name"}
                                              dataKey={"id"}
                                              onChange={async (event) => {
                                                setLoading(true);
                                                await handleChangeIngredientTransport(event, x, i, current[1].origin);
                                                setLoading(false);
                                              }}
                                              renderValue={({ item }) => (
                                                <Tooltip title={x.flow.name_fr} arrow>
                                                  <p>{x.flow.name_fr}</p>
                                                </Tooltip>
                                              )}
                                            />
                                          </div>

                                          <div className="flex-auto h-[40px] border-dotted border-l-[1px] text-xs border-[#F3F5F7] flex justify-center items-center">
                                            <Tooltip title={x.amount + " " + x.unit.name} arrow>
                                              {/* <p>{current.flow.name_fr}</p> */}
                                              <p>
                                                <input
                                                  onWheel={(e) => e.target.blur()}
                                                  type={"number"}
                                                  // value={parseFloat(parseFloat(current.amount).toFixed(5))}
                                                  value={x.amount}
                                                  className={"text-right w-[50px] bg-transparent"}
                                                  min={0}
                                                  onChange={(event) => {
                                                    handleChangeIngredientTransportQuantity(event, x, i);
                                                    // console.log("event", current)
                                                  }}
                                                  // renderValue={({ item }) => (
                                                  //   <Tooltip title={current.flow.name_fr} arrow>
                                                  //     <p>{current.flow.name_fr}</p>
                                                  //   </Tooltip>
                                                  // )}
                                                />
                                                {" " + x.unit.name}
                                              </p>
                                            </Tooltip>
                                          </div>

                                          <div className="flex-auto h-[40px] border-dotted border-l-[1px] border-[#F3F5F7] flex justify-center items-center text-xs">
                                            <p>
                                              {parseFloat(x.amount * x.flow.flow_impact_factors.find((x) => x.id === modIndex).coefficient * x.unit.conversion_factor).toExponential(2)}{" "}
                                              {x.flow.flow_impact_factors.find((x) => x.id === modIndex).unit}
                                            </p>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}

                                {/* ADD TRANSPORT */}
                                <div className="h-[40px] w-full flex bg-[#F3F5F7]">
                                  {/* <div className="h-[40px] w-[465px] border-dotted border-r-[1px] border-[#F3F5F7] flex items-center"> */}
                                  <button
                                    className="h-[40px] w-[465px] border-dotted border-r-[1px] border-[#F3F5F7] flex items-center"
                                    onClick={async () => {
                                      setLoading(true);
                                      await handleChangeAddIngredientTransport(current[1].origin);

                                      setLoading(false);
                                    }}
                                  >
                                    {loading ? <ComponentLoading height={20} style={"flex items-center justify-center ml-[11px]"} /> : <Plus height={15} />}
                                    <p className="text-sm text-gray-400">Ajouter un transport</p>
                                  </button>
                                  {/* </div> */}
                                  <div className="w-[125px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7]" />
                                  <div className="w-[125px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7]" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}

                <div className="h-[40px] w-full flex bg-[#F3F5F7]">
                  <button
                    className="h-[40px] w-[305px] border-dotted border-r-[1px] border-[#F3F5F7] flex items-center"
                    onClick={async () => {
                      setLoading(true);
                      await handleChangeAddOrigin();
                      setLoading(false);
                    }}
                  >
                    {loading ? <ComponentLoading height={20} style={"flex items-center justify-center ml-[11px]"} /> : <Plus height={15} />}
                    <p className="text-sm text-gray-400">Ajouter une origine</p>
                  </button>
                  <div className="w-[305px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7]"></div>
                </div>
              </>
            )}

            {/* OTHER STEPS */}
            {step > 2 ? (
              <>
                <div className="w-[695px] h-[320px] bg-[#F3F5F7]/40 rounded-t shadow">
                  <div className="h-[40px] w-full flex items-center font-Poppins-SemiBold bg-white">
                    <div className="w-[480px] h-[40px] border-dotted border-r-[1px] border-[#F3F5F7] flex justify-center items-center">
                      <p> Type</p>
                    </div>
                    <div className="w-[165px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7] flex justify-center items-center">
                      <p> {getTypeParameterText(data.flow.category.name)}</p>
                    </div>
                    <div className="w-[130px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7] flex justify-center items-center">
                      <p> Impact</p>
                    </div>
                  </div>

                  <div className="flex bg-[#F3F5F7]">
                    <div className="h-[40px] w-[480px] flex items-center border-dotted border-r-[1px] border-[#F3F5F7]">
                      <DropdownList
                        filter={"contains"}
                        value={item}
                        className="h-full w-[250px] bg-[#F3F5F7] py-[2px] mx-[10px] "
                        data={flow_type_meta ? flow_type_meta : []}
                        // data={flow_type_meta}
                        textField={"name"}
                        dataKey={"id"}
                        onChange={async (value) => {
                          await handleChangeFlow(value, item);
                        }}
                        renderValue={({ item }) => (
                          <Tooltip title={item} arrow>
                            <p>{item}</p>
                          </Tooltip>
                        )}
                      />
                    </div>
                    <div className="w-[165px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7] flex justify-center items-center">
                      <p>
                        <input onWheel={(e) => e.target.blur()} type={"number"} value={quantity} className={"text-right w-[80px] bg-transparent"} min={0} onChange={handleChangeFlowQuantity} />
                        {" " + quantityUnit}
                      </p>
                    </div>
                    <div className="w-[135px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7] flex justify-center items-center">
                      <p>
                        {parseFloat(quantity * imapct_factors.find((x) => x.id === modIndex).coefficient * data.unit.conversion_factor).toExponential(2)}{" "}
                        {imapct_factors.find((x) => x.id === modIndex).unit}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col w-[695px] pt-[20px]">
                  <div className="flex pt-[5px]">
                    <p className="font-Poppins-SemiBold text-base">Description</p>
                  </div>
                  <div className="flex w-[695px]">
                    <textarea onWheel={(e) => e.target.blur()} type="textarea" value={description.length > 0 ? description : "-"} className={"w-[695px] h-[100px] bg-white"} onChange={handleChangeFlowDescription} />
                  </div>
                </div>
              </>
            ) : null}
          </div>

          {data && !data.name && (
            <div className="w-[50px] h-full bg-[#F3F5F7]">
              <div className="w-[50px] mt-[100px]">
                {columns.map((current, i) => {
                  return (
                    <div key={`${i}`}>
                      {current !== "Quantity" && current !== "Valider" ? (
                        <button
                          className={`h-[60px] w-full border-gray-500/30 ${current === modIndex ? "bg-white border-y-[1px]" : "bg-[#F3F5F7] border-[1px]"} text-xs text-center`}
                          onClick={() => {
                            setModIndex(current);
                          }}
                        >
                          {impact_indicators.find((i) => i.id === current).name.fr}
                        </button>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {data && !data.name ? (
            <button
              className="absolute bottom-[30px]"
              onClick={async () => {
                await handleChangeRemoveFlow();
              }}
            >
              <p className="font-Poppins-SemiBold text-mainGreen text-sm">Supprimer</p>
            </button>
          ) : (
            <button
              className="absolute top-[150px]"
              onClick={async () => {
                await handleChangeRemoveFlow();
              }}
            >
              <p className="font-Poppins-SemiBold text-mainGreen text-sm">Supprimer</p>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModificationLine;
